import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { useSiteMetadata } from '@hooks/use-site-metadata'

const Metadata = ({
  title = '',
  description = '',
  banner = '',
  seoBanner,
  noIndex = false,
  keywords,
  ogTitle,
  ogDescription,
  twTitle,
  twDescription,
  jsonTitle,
  jsonDescription,
}) => {
  const {
    siteMetadata: {
      banner: siteBanner,
      url: siteUrl,
      title: siteTitle,
      description: siteDescription,
      keywords: siteKeywords,
      og_title,
      og_description,
      tw_title,
      tw_description,
      json_title,
      json_description,
    },
  } = useSiteMetadata()

  const metaTitle = title || siteTitle
  const metaDescription = description || siteDescription
  const metaBanner = banner
    ? `${siteUrl}${banner}`
    : seoBanner
      ? seoBanner
      : siteBanner
  const metaKeywords = keywords || siteKeywords
  const openGraphTitle = ogTitle || og_title
  const openGraphDescription = ogDescription || og_description
  const twitterTitle = twTitle || tw_title
  const twitterDescription = twDescription || tw_description
  const structuredTitle = jsonTitle || json_title
  const structuredDescription = jsonDescription || json_description

  return (
    <Helmet>
      {/* General */}
      <title>{metaTitle}</title>
      <link rel="preconnect" href="https://api.storyblok.com" />

      {structuredTitle && structuredDescription && (
        <script type="application/ld+json">{`
        [{
          "@context": "https://schema.org/",
          "@type": "CollectionPage",
          "name": "${structuredTitle}",
          "description": "${structuredDescription}"
        }]
      `}</script>
      )}

      <meta name="description" content={metaDescription} />

      {metaKeywords !== '' && <meta name="keywords" content={metaKeywords} />}

      <meta name="image" content={metaBanner} />

      {/* Open Graph */}
      <meta property="og:title" content={openGraphTitle} />
      <meta property="og:description" content={openGraphDescription} />
      <meta property="og:image" content={metaBanner} />
      <meta property="og:image:width" content="1080" />
      <meta property="og:image:height" content="565" />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={metaBanner} />

      {/* Noindexing */}
      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

Metadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  banner: PropTypes.string,
  noIndex: PropTypes.bool,
}

export default Metadata
